/* tslint:disable */
/* eslint-disable */
/**
 * WSK APIドキュメント
 *  WSK APIドキュメント  ## レスポンス形式 - result     - **status**：     - **message**：     - **system_date**：     - **pageno**： - data     - list         - **datacount**：         - **maxcount**：         - **list**：   ### result.status - **success**：正常終了 - **error**：入力エラー、権限エラー - **warning**：警告で、通知する必要のあるメッセージがある - **info**：正常処理で、通知する必要のあるメッセージがある  
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 出荷数量20
 * @export
 * @interface Col20
 */
export interface Col20 {
}

/**
 * Check if a given object implements the Col20 interface.
 */
export function instanceOfCol20(value: object): value is Col20 {
    return true;
}

export function Col20FromJSON(json: any): Col20 {
    return Col20FromJSONTyped(json, false);
}

export function Col20FromJSONTyped(json: any, ignoreDiscriminator: boolean): Col20 {
    return json;
}

export function Col20ToJSON(json: any): Col20 {
    return Col20ToJSONTyped(json, false);
}

export function Col20ToJSONTyped(value?: Col20 | null, ignoreDiscriminator: boolean = false): any {
    return value;
}

